module.exports = __webpack_public_path__ + "img/arrow_tail_right.53982af7.svg";